document.addEventListener('DOMContentLoaded', () => {

    const mainForm = document.getElementById('product-form-main');
    const mobileForm = document.getElementById('product-form-mobile');
    document.addEventListener('scroll', () => {
        if(aboveViewport(mainForm) && window.innerWidth <= 749){
            mobileForm.style.display = 'block';
            mobileForm.style.opacity = '1';
        }else{
            mobileForm.style.display = 'none';
            mobileForm.style.opacity = '0';
        }
    });
});

const aboveViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
        rect.bottom <= 0
    );
}